export const colors = {
  red: 'rgba(250, 128, 114, 0.5)',
  orange: 'rgba(255, 165, 0, 0.5)',
  green: 'rgba(154, 205, 50, 0.5)',
  blue: 'rgba(70, 130, 180, 0.5)',
};
